var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0854702 17.1449L14.4569 0.480386C14.5868 0.329595 14.7474 0.20866 14.9278 0.125778C15.1082 0.0428949 15.3042 0 15.5026 0C15.7009 0 15.8969 0.0428949 16.0773 0.125778C16.2577 0.20866 16.4183 0.329595 16.5483 0.480386L30.9153 17.1449C30.9587 17.1951 30.9869 17.2568 30.9964 17.3227C31.0059 17.3886 30.9964 17.4558 30.9691 17.5164C30.9417 17.577 30.8976 17.6284 30.842 17.6645C30.7864 17.7006 30.7217 17.7198 30.6555 17.7199H27.1482C26.949 17.7199 26.7585 17.6328 26.6242 17.4803L17.1458 6.48831L17.3363 38.6515C17.3363 38.8432 17.1804 39 16.9899 39H14.3919C14.2014 39 14.0455 38.8432 14.0455 38.6515L13.855 6.48831L4.37653 17.4803C4.24663 17.6328 4.05611 17.7199 3.8526 17.7199H0.345272C0.0508289 17.7199 -0.109381 17.3714 0.0854702 17.1449Z",
    fill: "#B0B0B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f65525deefc201567a7164cc85343d58.svg";
export { ForwardRef as ReactComponent };